import * as Yup from 'yup';

/*
    What the server already refuses, checked here so an admin sees it beside the field instead of in
    a failure message after a long save.

    Two server rules are not here, because neither maps to a field on this form. The exam flag and
    the assessments cannot change once assessment editing is locked, and the page does guard that:
    the checkbox, the remove controls and the lesson list all respect it. An image is required once
    the course has been published, and the page does not guard that one — the server refuses the
    save and the message reaches the admin in a toast.
*/
export const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required('A course needs a title.'),

    chapters: Yup.array().of(
        Yup.object().shape({
            title: Yup.string().trim().required('A chapter needs a title.'),

            lesson_hashes: Yup.array()
                .of(Yup.object().shape({ lesson_id: Yup.string().required() }))
                .test('no-duplicate-lessons', 'A lesson can only appear once in a chapter.', lessonHashes => {
                    const lessonIds = (lessonHashes || []).map(lessonHash => lessonHash.lesson_id);
                    return new Set(lessonIds).size === lessonIds.length;
                }),
        }),
    ),

    // Lesson::Stream#validate_summaries_have_lessons refuses a summary that covers nothing.
    summaries: Yup.array().of(
        Yup.object().shape({
            lessons: Yup.array().min(1, 'A summary needs at least one lesson.'),
        }),
    ),
});
